import { render } from "./borderlessTable.vue?vue&type=template&id=495201ee"
import script from "./borderlessTable.vue?vue&type=script&lang=js"
export * from "./borderlessTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__